import { Map as ImmutableMap } from 'immutable';

export default function combineImmutableReducers(reducers) {
  const entries = Object.entries(reducers);

  return (state = ImmutableMap(), action) => {
    let nextState = state;
    for (const [key, reducer] of entries) {
      const previousSlice = state.get(key);
      const nextSlice = reducer(previousSlice, action);
      if (nextSlice === undefined) {
        throw new Error(
          `Reducer "${key}" returned undefined for action "${action.type}"`,
        );
      }
      if (nextSlice !== previousSlice) {
        nextState = nextState.set(key, nextSlice);
      }
    }
    return nextState;
  };
}
